function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Contract_Incoming",
  "data-name": "Contract Incoming",
  transform: "translate(-1141.802 -205)"
}, /*#__PURE__*/React.createElement("g", {
  id: "invoice",
  transform: "translate(1150 205)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M14.168,15.989a.436.436,0,0,1-.232-.068L12.1,14.734l-1.832,1.184a.432.432,0,0,1-.468,0L7.958,14.731,6.125,15.915a.431.431,0,0,1-.467,0l-1.84-1.187L1.987,15.911a.427.427,0,0,1-.433.021.409.409,0,0,1-.221-.362V.819H.422A.416.416,0,0,1,0,.41.416.416,0,0,1,.422,0H15.543a.426.426,0,0,1,.422.419.416.416,0,0,1-.422.41h-.96l.007,14.752a.407.407,0,0,1-.221.361A.47.47,0,0,1,14.168,15.989ZM7.959,13.823a.429.429,0,0,1,.234.069l1.839,1.187,1.832-1.187a.432.432,0,0,1,.468,0l1.417.914,0-13.991H2.177V14.8l1.409-.911a.432.432,0,0,1,.468,0l1.839,1.184,1.832-1.184A.426.426,0,0,1,7.959,13.823Z",
  transform: "translate(0.012)",
  fill: "#222"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M.422.819h4.42A.417.417,0,0,0,5.264.409.417.417,0,0,0,4.842,0H.422A.417.417,0,0,0,0,.409.415.415,0,0,0,.422.819Z",
  transform: "translate(3.708 5.718)",
  fill: "#222"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-2",
  "data-name": "Path",
  d: "M.422.819H3.735A.417.417,0,0,0,4.156.409.417.417,0,0,0,3.735,0H.422A.417.417,0,0,0,0,.409.415.415,0,0,0,.422.819Z",
  transform: "translate(3.708 7.14)",
  fill: "#222"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-3",
  "data-name": "Path",
  d: "M.422.819h1.1A.417.417,0,0,0,1.948.409.417.417,0,0,0,1.526,0H.422A.417.417,0,0,0,0,.409.415.415,0,0,0,.422.819Z",
  transform: "translate(10.337 5.718)",
  fill: "#222"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-4",
  "data-name": "Path",
  d: "M.422.819h1.1A.417.417,0,0,0,1.948.409.417.417,0,0,0,1.526,0H.422A.417.417,0,0,0,0,.409.415.415,0,0,0,.422.819Z",
  transform: "translate(10.337 7.14)",
  fill: "#222"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-5",
  "data-name": "Path",
  d: "M.422.819h4.42A.417.417,0,0,0,5.264.409.417.417,0,0,0,4.842,0H.422A.417.417,0,0,0,0,.409.415.415,0,0,0,.422.819Z",
  transform: "translate(3.708 2.432)",
  fill: "#222"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-6",
  "data-name": "Path",
  d: "M.422.819H3.735A.417.417,0,0,0,4.156.409.417.417,0,0,0,3.735,0H.422A.417.417,0,0,0,0,.409.415.415,0,0,0,.422.819Z",
  transform: "translate(3.708 3.852)",
  fill: "#222"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-7",
  "data-name": "Path",
  d: "M.422.819h1.1A.417.417,0,0,0,1.948.409.417.417,0,0,0,1.526,0H.422A.417.417,0,0,0,0,.409.415.415,0,0,0,.422.819Z",
  transform: "translate(10.337 2.432)",
  fill: "#222"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-8",
  "data-name": "Path",
  d: "M.422.819h1.1A.417.417,0,0,0,1.948.409.417.417,0,0,0,1.526,0H.422A.417.417,0,0,0,0,.409.415.415,0,0,0,.422.819Z",
  transform: "translate(10.337 3.852)",
  fill: "#222"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-9",
  "data-name": "Path",
  d: "M.422.819h4.42A.417.417,0,0,0,5.264.409.417.417,0,0,0,4.842,0H.422A.417.417,0,0,0,0,.409.415.415,0,0,0,.422.819Z",
  transform: "translate(3.708 9.044)",
  fill: "#222"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-10",
  "data-name": "Path",
  d: "M.422.819H3.735A.417.417,0,0,0,4.156.409.417.417,0,0,0,3.735,0H.422A.417.417,0,0,0,0,.409.415.415,0,0,0,.422.819Z",
  transform: "translate(3.708 10.463)",
  fill: "#222"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-11",
  "data-name": "Path",
  d: "M.422.819h1.1A.417.417,0,0,0,1.948.409.417.417,0,0,0,1.526,0H.422A.417.417,0,0,0,0,.409.415.415,0,0,0,.422.819Z",
  transform: "translate(10.337 9.044)",
  fill: "#222"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-12",
  "data-name": "Path",
  d: "M.422.819h1.1A.417.417,0,0,0,1.948.409.417.417,0,0,0,1.526,0H.422A.417.417,0,0,0,0,.409.415.415,0,0,0,.422.819Z",
  transform: "translate(10.337 10.463)",
  fill: "#222"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_271",
  "data-name": "Path 271",
  d: "M7.043,8.64a.486.486,0,0,1-.359.14.491.491,0,0,1-.5-.491l-.07-1.53H0V2.006H6.113L6.128.5a.5.5,0,0,1,.5-.5A.586.586,0,0,1,7,.155l4.982,3.82a.464.464,0,0,1,.141.343.485.485,0,0,1-.141.359L7.262,8.469Z",
  transform: "translate(1142.202 206)",
  fill: "#222",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 0.8
}));

var SvgContractIncoming = function SvgContractIncoming(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.175,
    height: 15.989,
    viewBox: "0 0 24.175 15.989",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContractIncoming, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contractIncoming.2e1f8dc3.svg";
export { ForwardRef as ReactComponent };